
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m48 64h132c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12h-132c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h132c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12h-132c-26.5 0-48-21.5-48-48v-288c0-26.5 21.5-48 48-48zm279 19.5-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l132 131.4h-279.9c-6.6 0-12 5.4-12 12v10c0 6.6 5.4 12 12 12h279.9l-131.9 131.4c-4.7 4.7-4.7 12.3 0 17l7.1 7.1c4.7 4.7 12.3 4.7 17 0l164.5-164c4.7-4.7 4.7-12.3 0-17l-164.6-164c-4.7-4.7-12.3-4.7-17 0z"}})])
          )
        }
      }
    